import {Nullish} from 'shared/web';

import {AuctionTypeFilter} from '../types/AuctionTypeFilter';

export function isHiddenAuctionType(type: string | Nullish): boolean {
  return type?.toLowerCase() === AuctionTypeFilter.HIDDEN;
}
